<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<style>
html,body{
        /*设置内部填充为0，几个布局元素之间没有间距*/
        padding: 0px;
         /*外部间距也是如此设置*/
        margin: 0px;
        /*统一设置高度为100%*/
        height: 100%;
    }

.el-container{
  height: 100%;
  width: 100%;
  background-size: 100% 100% !important;
  
}    

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*设置内部填充为0，几个布局元素之间没有间距*/
  padding: 0px;
  /*外部间距也是如此设置*/
  margin: 0px;
  /*统一设置高度为100%*/
  height: 100%;
}
</style>
<script>
//import router from './router'

export default {
  mounted:function(){
    //gotoLogin();
  },
  methods:{
    gotoMain(){
      router.replace('/cjIndex');
      //router.push('/cjIndex');
      if(this.userName == "cs" && this.pwdStr == "123456"){
        
      }
    },
    addShop(){
      var o = {qu:"长宁区",name:"hsopname"+this.indexNum,address:"addresssssss"+this.indexNum};
      this.indexNum +=1;
      this.shopShow.push(o);
      //let container = this.$el.querySelector(".el-card");
      //container.scrollTop = container.scrollHeight;
    },
    showalert(){
      console.log('123');
      this.centerDialogVisible = false;

      this.mohuStyle={
        'filter': 'none'
      };
    }
  }
}
</script>